/* PureVie Bio — interactions globales */
(function () {
  'use strict';

  var CURRENCY = document.documentElement.getAttribute('data-currency') || 'EUR';
  var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CURRENCY });
  function money(cents) { return fmt.format(cents / 100); }

  // Parse JSON défensif : rejette proprement si Shopify renvoie du HTML
  // (page de challenge, préview de l'éditeur de thème, etc.).
  // NB : Shopify sert /cart.js en "text/javascript" — on parse le texte
  // plutôt que de se fier au content-type.
  function asJson(r) {
    return r.text().then(function (t) {
      var data;
      try { data = JSON.parse(t); } catch (e) { throw new Error('cart'); }
      if (!r.ok) throw new Error(data.description || data.message || 'cart');
      return data;
    });
  }

  /* ---------- Barre d'annonce rotative ---------- */
  var ann = document.getElementById('announcement');
  if (ann) {
    var items = ann.querySelectorAll('.announcement__item');
    if (items.length > 1) {
      var current = 0;
      setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, 4000);
    }
  }

  /* ---------- Carrousel héro ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = track.children;
    var dotsWrap = carousel.parentElement.querySelector('[data-carousel-dots]');
    var index = 0;
    var timer = null;

    if (slides.length <= 1) return;

    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.className = 'carousel__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dot.dataset.index = i;
      dotsWrap.appendChild(dot);
    }
    var dots = dotsWrap.children;

    function go(n) {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === index);
    }
    function restartAuto() {
      if (timer) clearInterval(timer);
      if (window.matchMedia('(min-width: 900px)').matches) {
        timer = setInterval(function () { go(index + 1); }, 4500);
      }
    }

    dotsWrap.addEventListener('click', function (e) {
      if (e.target.dataset.index !== undefined) { go(+e.target.dataset.index); restartAuto(); }
    });
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); restartAuto(); });
    if (next) next.addEventListener('click', function () { go(index + 1); restartAuto(); });

    // Swipe mobile
    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); restartAuto(); }
    }, { passive: true });

    restartAuto();
  });

  /* ---------- Buy box : sélection de bundle + panier ---------- */
  var DAYS_PER_BOTTLE = 60; // 120 capsules, 2/jour

  function bottleCount(variant, idx) {
    var m = (variant.title || '').match(/(\d+)/);
    if (m) { var n = parseInt(m[1], 10); if (n >= 1 && n <= 6) return n; }
    return idx + 1;
  }

  document.querySelectorAll('[data-buy-box]').forEach(function (box) {
    var variantsEl = box.querySelector('[data-variants]');
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    // Abonnement (présent uniquement si un plan de vente existe sur le produit)
    var plans = null;
    var plansEl = box.querySelector('[data-selling-plans]');
    if (plansEl) { try { plans = JSON.parse(plansEl.textContent); } catch (e) { plans = null; } }
    var subToggle = box.querySelector('[data-subscribe-toggle]');

    var options = box.querySelectorAll('.bundle__option');
    var perDayEl = box.querySelector('[data-per-day]');
    var addBtn = box.querySelector('[data-add-to-cart]');
    var btnPrice = box.querySelector('[data-btn-price]');

    function selected() {
      return box.querySelector('.bundle__option.is-selected');
    }
    function subscribed() {
      return !!(subToggle && subToggle.querySelector('input').checked && plans);
    }
    function effectivePrice(variant) {
      if (subscribed() && plans.allocations[variant.id]) return plans.allocations[variant.id];
      return variant.price;
    }

    function update() {
      var opt = selected();
      if (!opt) return;
      var vid = +opt.dataset.variantId;
      var variant = variants.find(function (v) { return v.id === vid; });
      if (!variant) return;

      var idx = Array.prototype.indexOf.call(options, opt);
      var bottles = bottleCount(variant, idx);
      var price = effectivePrice(variant);
      var perCap = price / (bottles * 120);

      // Recalcule TOUTES les lignes de chaque option selon l'état de l'abonnement :
      // prix principal, prix barré, chip "Économisez", prix / flacon et / jour.
      options.forEach(function (o, i) {
        var v = variants.find(function (x) { return x.id === +o.dataset.variantId; });
        if (!v) return;
        var b = bottleCount(v, i);
        var eff = effectivePrice(v);
        var isSub = subscribed() && eff < v.price;

        // Ancre de comparaison : compare_at si défini, sinon le prix normal quand abonné
        var anchor = null;
        if (v.compare_at_price && v.compare_at_price > eff) anchor = v.compare_at_price;
        else if (eff < v.price) anchor = v.price;

        var nowEl = o.querySelector('[data-price-now]');
        if (nowEl) {
          nowEl.textContent = money(eff);
          nowEl.classList.toggle('is-sub', isSub);
        }
        var compareEl = o.querySelector('[data-compare]');
        if (compareEl) {
          compareEl.classList.toggle('hidden', !anchor);
          if (anchor) compareEl.textContent = money(anchor);
        }
        var saveEl = o.querySelector('[data-save]');
        if (saveEl) {
          var savings = anchor ? anchor - eff : 0;
          saveEl.classList.toggle('hidden', savings <= 0);
          if (savings > 0) saveEl.textContent = 'Économisez ' + money(savings);
        }
        var sublineEl = o.querySelector('[data-subline]');
        if (sublineEl) {
          var perBottle = eff / b;
          var pc = eff / (b * 120);
          sublineEl.textContent = (b > 1 ? money(perBottle) + ' / flacon · ' : '') + money(pc) + ' / capsule';
        }
      });

      if (perDayEl) {
        perDayEl.textContent = 'Soit seulement ' + money(perCap) + ' par capsule' +
          (subscribed() ? ' — livré tous les 2 mois, annulable à tout moment' : '');
      }
      if (btnPrice) btnPrice.textContent = money(price);

      // Synchronise le CTA sticky mobile
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyPerday = document.querySelector('[data-sticky-perday]');
      if (stickyPrice && box.dataset.formId === 'hero') {
        stickyPrice.textContent = money(price);
        if (stickyPerday) stickyPerday.textContent = money(perCap) + ' / capsule';
      }
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var input = opt.querySelector('input');
        if (input) input.checked = true;
        update();
      });
    });

    if (subToggle) {
      subToggle.querySelector('input').addEventListener('change', function () {
        subToggle.classList.toggle('is-checked', this.checked);
        update();
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var opt = selected();
        if (!opt) return;
        var payload = { id: +opt.dataset.variantId, quantity: 1 };
        if (subscribed()) payload.selling_plan = +plans.planId;

        var original = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.addingText || 'Ajout en cours…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            if (!r.ok) {
              // Remonte le vrai message d'erreur Shopify — sans jamais afficher
              // d'erreur de parsing brute si la réponse n'est pas du JSON
              return r.text().then(function (t) {
                var msg = 'Une erreur est survenue. Veuillez réessayer.';
                try {
                  var e2 = JSON.parse(t);
                  msg = e2.description || e2.message || msg;
                } catch (ignore) { /* réponse HTML (éditeur de thème, challenge) */ }
                throw new Error(msg);
              });
            }
            // Ajoute automatiquement la protection de commande si absente (retirable dans le panier).
            // Non bloquant : si cet ajout échoue, la commande principale reste dans le panier.
            var upsellSrc = document.querySelector('[data-drawer-upsell]');
            if (!upsellSrc) return null;
            return fetch('/cart.js')
              .then(asJson)
              .then(function (cart) {
                var has = cart.items.some(function (item) { return item.handle === 'protection-de-commande'; });
                if (has) return null;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: +upsellSrc.dataset.variantId, quantity: 1 })
                });
              })
              .catch(function () { return null; });
          })
          .then(function () {
            addBtn.disabled = false;
            addBtn.innerHTML = original;
            // Ouvre le tiroir panier ; à défaut, redirige vers /cart
            if (window.PVDrawer) { window.PVDrawer.open(); }
            else { window.location.href = '/cart'; }
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.innerHTML = original;
            alert(err && err.message ? err.message : "Une erreur est survenue. Veuillez réessayer.");
          });
      });
    }

    update();
  });

  /* ---------- Tiroir panier ---------- */
  (function () {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
    var countEl = drawer.querySelector('[data-drawer-count]');
    var upsellEl = drawer.querySelector('[data-drawer-upsell]');

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s || '';
      return d.innerHTML;
    }

    var UPSELL_HANDLES = ['protection-de-commande', 'complexe-betterave-5-en-1-flacon-exclusif-35'];
    function isUpsellItem(item) { return UPSELL_HANDLES.indexOf(item.handle) !== -1; }

    function render(cart) {
      // Règle : les upsells n'existent qu'en accompagnement d'un vrai produit.
      // Si le panier ne contient plus que des upsells, on le vide.
      var hasReal = cart.items.some(function (item) { return !isUpsellItem(item); });
      if (!hasReal && cart.items.length) {
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () { return refresh(); })
          .catch(function () {});
        return;
      }

      if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

      // Badge de l'icône panier dans le header
      var iconCount = document.querySelector('[data-cart-icon-count]');
      if (iconCount) {
        iconCount.textContent = cart.item_count;
        iconCount.classList.toggle('hidden', cart.item_count === 0);
      }

      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="drawer__empty">Votre panier est vide.</p>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (item, i) {
          var line = i + 1;
          var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_128x128$1$2') + '" alt="" width="64" height="64">' : '<span style="width:64px"></span>';
          var variant = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="drawer-line__variant">' + esc(item.variant_title) + '</p>' : '';
          var plan = item.selling_plan_allocation
            ? '<p class="drawer-line__plan">' + esc(item.selling_plan_allocation.selling_plan.name) + '</p>' : '';
          // Offre unique / protection : quantité verrouillée à 1, pas de +/−
          var qty = isUpsellItem(item)
            ? '<span class="drawer-line__qty"><span>Qté : 1 (offre unique)</span></span>'
            : '<span class="drawer-line__qty">' +
                '<button type="button" data-drawer-qty data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Réduire">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-drawer-qty data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Augmenter">+</button>' +
              '</span>';
          return '<div class="drawer-line">' + img +
            '<div class="drawer-line__info">' +
              '<p class="drawer-line__title">' + esc(item.product_title) + '</p>' + variant + plan + qty +
            '</div>' +
            '<div><span class="drawer-line__price">' + money(item.final_line_price) + '</span>' +
            '<a href="#" class="drawer-line__remove" data-drawer-qty data-line="' + line + '" data-qty="0">Retirer</a></div>' +
          '</div>';
        }).join('');
      }

      // Upsell protection : visible seulement si un vrai produit est là et protection absente
      if (upsellEl) {
        var hasProtection = cart.items.some(function (item) { return item.handle === 'protection-de-commande'; });
        upsellEl.classList.toggle('hidden', hasProtection || !hasReal);
      }

      // Upsell abonnement : visible si le produit principal est au panier SANS abonnement
      var subUpsell = drawer.querySelector('[data-drawer-sub-upsell]');
      if (subUpsell) {
        var oneTimeLine = cart.items.some(function (item) {
          return item.product_id === +subUpsell.dataset.productId && !item.selling_plan_allocation;
        });
        subUpsell.classList.toggle('hidden', !oneTimeLine);
      }

      // Offre exclusive « bundle-diff » : le flacon bonus coûte exactement la
      // différence avec le bundle supérieur — que la ligne soit un achat unique
      // ou un abonnement. Le total final = le bundle supérieur pris directement.
      var offerEl = drawer.querySelector('[data-drawer-offer]');
      if (offerEl) {
        var hasOffer = cart.items.some(function (item) {
          return item.product_id === +offerEl.dataset.productId;
        });
        var offerVariants = [], mainVariants = [], mainPlans = null;
        try { offerVariants = JSON.parse(offerEl.querySelector('[data-offer-variants]').textContent); } catch (e) {}
        try { mainVariants = JSON.parse(offerEl.querySelector('[data-main-variants]').textContent); } catch (e) {}
        var mpEl = offerEl.querySelector('[data-main-plans]');
        if (mpEl) { try { mainPlans = JSON.parse(mpEl.textContent); } catch (e) {} }

        var mainLine = cart.items.find(function (item) { return item.handle === 'complexe-betterave-5-en-1'; });
        var bottles = 0;
        if (mainLine) {
          var m = (mainLine.variant_title || '').match(/(\d)/);
          bottles = m ? +m[1] : 1;
        }

        var show = false;
        var priceShown = 0;
        // Valeur de référence du flacon pour le badge % : le prix réel du 1 Flacon
        var FULL_BOTTLE = 2999;
        var oneBottle = mainVariants.find(function (v) { return (v.title || '').indexOf('1') === 0; });
        if (oneBottle && oneBottle.price) FULL_BOTTLE = oneBottle.price;

        if (mainLine && bottles > 0 && bottles < 3 && hasReal) {
          if (mainLine.selling_plan_allocation && mainPlans) {
            // ABONNEMENT : upgrade de la ligne vers le bundle supérieur, même plan.
            var nextTitle = (bottles + 1) + ' Flacon';
            var targetVar = mainVariants.find(function (v) { return (v.title || '').indexOf(String(bottles + 1)) === 0; });
            var targetSubPrice = targetVar ? mainPlans.allocations[targetVar.id] : null;
            if (targetVar && targetSubPrice) {
              var diff = targetSubPrice - mainLine.final_price;
              if (diff > 0) {
                show = true;
                priceShown = diff;
                offerEl.dataset.mode = 'upgrade';
                offerEl.dataset.targetId = targetVar.id;
                offerEl.dataset.planId = mainLine.selling_plan_allocation.selling_plan.id;
                offerEl.dataset.lineKey = mainLine.key;
                offerEl.dataset.qty = mainLine.quantity;
              }
            }
          } else if (!hasOffer) {
            // ACHAT UNIQUE : produit bonus séparé au prix de la différence.
            var target = null;
            if (bottles === 1) target = offerVariants.find(function (v) { return /2/.test(v.title); });
            else if (bottles === 2) target = offerVariants.find(function (v) { return /3/.test(v.title); });
            if (target) {
              show = true;
              priceShown = target.price;
              offerEl.dataset.mode = 'add';
              offerEl.dataset.variantId = target.id;
            }
          }
        }

        offerEl.classList.toggle('hidden', !show);
        if (show) {
          var priceEl = offerEl.querySelector('[data-offer-price]');
          if (priceEl) priceEl.textContent = money(priceShown);
          var badgeEl = offerEl.querySelector('[data-offer-badge]');
          if (badgeEl) badgeEl.textContent = '-' + Math.round((1 - priceShown / FULL_BOTTLE) * 100) + '%';
        }
      }
    }

    function refresh() {
      return fetch('/cart.js')
        .then(asJson)
        .then(render);
    }

    function open() {
      refresh()
        .then(function () {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        })
        .catch(function () { window.location.href = '/cart'; });
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { close(); return; }

      var qtyBtn = e.target.closest('[data-drawer-qty]');
      if (qtyBtn) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: +qtyBtn.dataset.line, quantity: +qtyBtn.dataset.qty })
        })
          .then(asJson)
          .then(render)
          .catch(function () {});
        return;
      }

      // Bascule la première ligne « achat unique » du produit principal vers l'abonnement
      var subUpsell = e.target.closest('[data-drawer-sub-upsell]');
      if (subUpsell) {
        fetch('/cart.js')
          .then(asJson)
          .then(function (cart) {
            for (var i = 0; i < cart.items.length; i++) {
              var item = cart.items[i];
              if (item.product_id === +subUpsell.dataset.productId && !item.selling_plan_allocation) {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: i + 1, quantity: item.quantity, selling_plan: +subUpsell.dataset.planId })
                });
              }
            }
            return null;
          })
          .then(function () { return refresh(); })
          .catch(function () {});
        return;
      }

      // Offre exclusive : ajout du flacon bonus (achat unique) OU upgrade de la
      // ligne abonnement vers le bundle supérieur (anti double-clic dans les 2 cas)
      if (e.target.closest('[data-drawer-offer-add]')) {
        var offerBox = drawer.querySelector('[data-drawer-offer]');
        if (offerBox && !offerBox.dataset.busy) {
          offerBox.dataset.busy = '1';
          var op;
          if (offerBox.dataset.mode === 'upgrade') {
            // 1. Ajoute le bundle supérieur avec le même plan d'abonnement
            // 2. Retire l'ancienne ligne (par sa clé — pas d'index qui bouge)
            op = fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: +offerBox.dataset.targetId,
                quantity: +offerBox.dataset.qty || 1,
                selling_plan: +offerBox.dataset.planId
              })
            }).then(function (r) {
              if (!r.ok) throw new Error('upgrade');
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: offerBox.dataset.lineKey, quantity: 0 })
              });
            });
          } else {
            op = fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: +offerBox.dataset.variantId, quantity: 1 })
            });
          }
          op
            .then(function () { return refresh(); })
            .catch(function () { return refresh(); })
            .then(function () { delete offerBox.dataset.busy; });
        }
        return;
      }

      var upsell = e.target.closest('[data-drawer-upsell]');
      if (upsell) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: +upsell.dataset.variantId, quantity: 1 })
        })
          .then(function () { return refresh(); })
          .catch(function () {});
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    window.PVDrawer = { open: open, close: close, refresh: refresh };

    // Icône panier du header : ouvre le tiroir (fallback : page /cart via href)
    var cartIcon = document.querySelector('[data-cart-icon]');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }

    // Badge à jour dès le chargement de la page (échec silencieux)
    refresh().catch(function () {});
  })();

  /* ---------- Upsell panier : protection de commande ---------- */
  var upsell = document.querySelector('[data-cart-upsell]');
  if (upsell) {
    upsell.addEventListener('click', function () {
      var variantId = +upsell.dataset.variantId;
      if (!variantId) return;
      upsell.style.opacity = '0.5';
      upsell.style.pointerEvents = 'none';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () { window.location.reload(); });
    });
  }

  /* ---------- CTA sticky mobile ---------- */
  var sticky = document.querySelector('[data-sticky-cta]');
  var heroBox = document.querySelector('.hero .buy-box');
  if (sticky && heroBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.scrollY > 300);
    }, { threshold: 0 }).observe(heroBox);

    var stickyAdd = sticky.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var heroAdd = document.querySelector('[data-buy-box][data-form-id="hero"] [data-add-to-cart]');
        if (heroAdd) heroAdd.click();
      });
    }
  }

  /* ---------- FAQ accordéon ---------- */
  document.querySelectorAll('[data-faq] .faq__item').forEach(function (item) {
    var q = item.querySelector('.faq__q');
    var a = item.querySelector('.faq__a');
    q.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open);
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });

  /* ---------- Nav active au scroll ---------- */
  var navLinks = document.querySelectorAll('.site-nav a[data-nav]');
  if (navLinks.length && 'IntersectionObserver' in window) {
    var sections = { bienfaits: '#bienfaits', ingredients: '#ingredients', avis: '#avis', faq: '#faq' };
    Object.keys(sections).forEach(function (key) {
      var el = document.querySelector(sections[key]);
      if (!el) return;
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          navLinks.forEach(function (l) { l.classList.toggle('is-active', l.dataset.nav === key); });
        }
      }, { rootMargin: '-30% 0px -60% 0px' }).observe(el);
    });
  }
})();
